import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { PinataPayTransactionResult } from "./pinata_pay_transaction_result.js";
//#region src/pinata_pay_transaction_result_helper.ts
var pinata_pay_transaction_result_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(result) {
	switch (result) {
		case PinataPayTransactionResult.Approval: return "Approval";
		case PinataPayTransactionResult.Decline: return "Decline";
		case PinataPayTransactionResult.PartialApproval: return "Partial Approval";
		case PinataPayTransactionResult.ProcessingError: return "Processing Error";
		case PinataPayTransactionResult.Invalid: return "Invalid";
		case PinataPayTransactionResult.Cancelled: return "Cancelled";
		case PinataPayTransactionResult.RefundFailure: return "Refund Failure";
		case PinataPayTransactionResult.Delayed: return "Delayed";
		default: throw new Error(`Unknown PinataPayTransactionResult: ${result}`);
	}
}
//#endregion
export { name, pinata_pay_transaction_result_helper_exports };

//# sourceMappingURL=pinata_pay_transaction_result_helper.js.map